import { UserRole } from '../api/enum/userRole.enum';
import { defineAbility } from '@casl/ability';
export default (role: string) =>
	defineAbility((can, cannot) => {
		staffListAbility(can, role);
	});

const staffListAbility = (
	can: (arg0: string, arg1: string, arg2?: string) => void,
	role: any
) => {
	switch (role) {
		case UserRole.ROLE_WEB_ADMIN: {
			can('create', 'staffList');
			can('edit', 'staffList');
			can('delete', 'staffList');
			// can('edit', 'staffList', UserRole.ROLE_SUPERVISOR);
			break;
		}
		case UserRole.ROLE_WEB_STAFF: {
			break;
		}
	}
};
